var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "13", height: "18", viewBox: "0 0 13 18", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "none" },
      React.createElement("path", { fill: "#FFF", d: "M3.857 3.857H9v10.286H3.857z" }),
      React.createElement("path", { d: "M8.571 0H1.286C.576 0 0 .576 0 1.286v12.428l2.143.429 2.143-.429V4.286H8.57L9 2.143 8.571 0z", fill: "#FBC02D" }),
      React.createElement("path", { fill: "#4CAF50", d: "M8.571 18H4.286l-.429-2.143.429-2.143H8.57L9 15.857z" }),
      React.createElement("path", { d: "M4.286 13.714V18h-3C.576 18 0 17.424 0 16.714v-3h4.286z", fill: "#2E7D32" }),
      React.createElement("path", { fill: "#1E88E5", d: "M12.857 13.714l-2.143.429-2.143-.429V4.286l2.143-.429 2.143.429z" }),
      React.createElement("path", { d: "M8.571 13.714h4.286v3c0 .71-.575 1.286-1.286 1.286h-3v-4.286z", fill: "#1565C0" }),
      React.createElement("path", { fill: "#E53935", d: "M12.857 4.286H8.571V0z" })
    )
  );
});